import { TaskData } from "../pages/stock/stock.service";
import { FcPivotModel } from "./forecast/fc-pivot-model";

export class BookMark {
  name: string;
  pageName: string;
  chartSettings: string; 
  isDefault: boolean;
  taskFilterData: TaskData[];
  pivotSettings: FcPivotModel;
  dataGridState: string;
}

export class BookmarkData {
  name: string;
  pageName: string;
  isDefault: boolean;
  BookmarkId: number; 
}